const RequestHeaders = { headers: { Accept: 'application/json' } };
export const GET_SUBACCOUNT_URL = 'Accounts/Subaccounts/GetSubaccounts';
export const CREATE_SUBACCOUNT_URL = 'Accounts/Subaccounts/CreateSubaccount';
export const UPDATE_SUBACCOUNT_URL = 'Accounts/Subaccounts/UpdateSubaccount';
export const TRANSFER_SUBACCOUNT_POSITIONS = 'Accounts/Subaccounts/TransferPositions';
export const UPDATE_DISTRIBUTION_RATIO = 'Accounts/Subaccounts/UpdateDistributionRatio';
export const DELETE_SUBACCOUNT_URL = 'Accounts/Subaccounts/DeleteSubaccount';
export const subaccounts = (api) => ({
    //returns object array
    getSubaccounts: (payload) => {
        return api.authenticated().get(GET_SUBACCOUNT_URL, payload, RequestHeaders);
    },
    createSubaccount: (createSubaccountPayload) => {
        return api.authenticated().post(CREATE_SUBACCOUNT_URL, createSubaccountPayload, RequestHeaders);
    },
    updateSubaccount: (updateSubaccountPayload) => {
        return api.authenticated().put(UPDATE_SUBACCOUNT_URL, updateSubaccountPayload, RequestHeaders);
    },
    transferPositions: (transferPositionsPayload) => {
        return api.authenticated().put(TRANSFER_SUBACCOUNT_POSITIONS, transferPositionsPayload, RequestHeaders);
    },
    updateDistributionRatio: (distributionRatioPayload) => {
        return api.authenticated().put(UPDATE_DISTRIBUTION_RATIO, distributionRatioPayload, RequestHeaders);
    },
    deleteSubaccount: (deleteSubaccountPayload) => {
        return api.authenticated().delete(DELETE_SUBACCOUNT_URL, deleteSubaccountPayload, RequestHeaders);
    },
});
//# sourceMappingURL=subaccounts.js.map